import React from 'react';
import { useHistory } from '@useHistory/useHistoryCompat';
import { GOOGLE_LOGIN_ERROR_QUERY_PARAM } from '../../constants/auth';
import { getErrorRedirectURLFromEncodedState } from '../../utils/googleLogin';
import { getErrorMessageFromObj } from '../../../core/utils/request';
import { appendQueryParams } from '../../../routing/utils/url';
import { HdResolvedComponent } from '../../../routing/components/resolved-component/HdResolvedComponent';
import { useLogin } from '../../hooks/useLogin';

export function GoogleLogin() {
  const history = useHistory();
  const { googleLogin } = useLogin();

  const redirectResolver = () => {
    const searchParams = new URLSearchParams(history.location?.search);

    const err = searchParams.get('error');
    const code = searchParams.get('code');
    const state = searchParams.get('state');

    if (err || code || state) {
      return googleLogin(err, code, state).catch((loginError: any) => {
        const errorUrl = getErrorRedirectURLFromEncodedState(state);

        history.replace(
          appendQueryParams(
            errorUrl,
            new URLSearchParams({
              [GOOGLE_LOGIN_ERROR_QUERY_PARAM]: btoa(getErrorMessageFromObj(loginError))
            }).toString()
          )
        );

        return null;
      });
    }
  };

  return (
    <HdResolvedComponent
      Component={GoogleLoginInner}
      resolve={{
        redirect: redirectResolver
      }}
    />
  );
}

function GoogleLoginInner() {
  return <></>;
}
